import api from './api';
import { qaInternalRoutes, GET } from '../constants/api';

// eslint-disable-next-line import/prefer-default-export
export const purgeRedisCache = keyOrPrefix =>
  api({
    method: GET,
    url: `${qaInternalRoutes.PURGE_REDIS_CACHE}/${encodeURIComponent(
      keyOrPrefix,
    )}`,
  });
